import { Button } from '@/components/ui/button';
import CopyIconButton from '@/components/ui/copy-to-clipboard/copy-icon-button';
import ConfirmationDialog from '@/components/ui/dialog-wrapper/ConfirmationDialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Separator } from '@/components/ui/separator';
import { useGetAuthToken, useRegenerateAuthToken } from '@/service/user/hook';

const Authtoken = () => {
  const { data } = useGetAuthToken();
  const { mutate } = useRegenerateAuthToken();
  const apikey = data;

  const handleRegenerateAPIKey = () => {
    mutate({});
  };
  return (
    <>
      <div className="container">
        <div>
          <span className="text-xl font-semibold">Tokens</span>
        </div>
        <Separator className="mb-6 mt-3" />
        <div>
          <Label className="">Auth Token</Label>
          <p className="my-2 text-xs text-muted-foreground">
            Grant access to actions in your account.
          </p>
          <div className="flex items-center gap-1.5">
            <div className="w-full max-w-md">
              <Input
                value={apikey}
                readOnly
                endIcon={<CopyIconButton text={apikey} />}
              />
            </div>
            <ConfirmationDialog
              title="Regenerate API Key"
              message="Are you sure you want to re-generate?"
              onConfirm={handleRegenerateAPIKey}
              confirmText="Regenerate new key"
            >
              <Button variant={'secondary'}>Re-generate</Button>
            </ConfirmationDialog>
          </div>
        </div>
      </div>
    </>
  );
};

export default Authtoken;
